import React from 'react';
import { CTAButton } from './CTAButton';
import { Shield, BookOpen, Headphones, Gift } from 'lucide-react';
export function PricingSection() {
  return <section className="bg-gray-100 py-16 px-4" data-id="element-153">
      <div className="max-w-xl mx-auto" data-id="element-154">
        <div className="bg-white rounded-2xl border-2 border-patriot-red shadow-2xl overflow-hidden relative" data-id="element-155">
          <div className="absolute top-0 inset-x-0 bg-patriot-red text-white text-xs font-bold text-center py-1.5 uppercase tracking-wide" data-id="element-156">
            Best Value — Limited Time Offer
          </div>

          <div className="bg-red-50 py-5 px-6 border-b border-red-100 mt-7" data-id="element-157">
            <h3 className="text-2xl font-bold text-navy text-center" data-id="element-158">
              eBook + Audiobook Bundle
            </h3>
            <p className="text-center text-gray-500 text-sm mt-1" data-id="element-159">
              Instant digital delivery — no shipping required
            </p>
          </div>

          <div className="p-8 flex flex-col items-center" data-id="element-160">
            <div className="mb-6 text-center" data-id="element-161">
              <span className="text-gray-400 line-through text-lg" data-id="element-162">$95.94</span>
              <div className="text-5xl font-bold text-patriot-red mt-1" data-id="element-163">
                $29.97
                <span className="text-base font-normal text-gray-500 ml-1" data-id="element-164">
                  USD
                </span>
              </div>
              <p className="text-green-600 font-bold text-sm mt-2" data-id="element-165">
                You save $65.97!
              </p>
            </div>

            <div className="w-full space-y-3 mb-6" data-id="element-166">
              <div className="flex items-center gap-3 text-gray-700" data-id="element-167">
                <BookOpen size={18} className="text-navy flex-shrink-0" data-id="element-168" />
                <span className="text-sm" data-id="element-169">
                  <strong data-id="element-170">Core eBook:</strong> Voices of Freedom
                </span>
              </div>
              <div className="flex items-center gap-3 text-gray-700" data-id="element-171">
                <Headphones size={18} className="text-navy flex-shrink-0" data-id="element-172" />
                <span className="text-sm" data-id="element-173">
                  <strong data-id="element-174">FREE Gift:</strong> Voices of Freedom Audiobook
                </span>
              </div>
              <div className="flex items-center gap-3 text-gray-700" data-id="element-175">
                <Gift size={18} className="text-patriot-red flex-shrink-0" data-id="element-176" />
                <span className="text-sm" data-id="element-177">
                  <strong data-id="element-178">BONUS #1:</strong> Remembering Charlie Kirk (eBook +
                  Audiobook)
                </span>
              </div>
              <div className="flex items-center gap-3 text-gray-700" data-id="element-179">
                <Gift size={18} className="text-patriot-red flex-shrink-0" data-id="element-180" />
                <span className="text-sm" data-id="element-181">
                  <strong data-id="element-182">BONUS #2:</strong> The Last Patriot (eBook +
                  Audiobook)
                </span>
              </div>
            </div>

            <div className="bg-yellow-50 border border-yellow-200 text-yellow-800 p-3 rounded-md mb-6 text-sm font-bold text-center w-full" data-id="element-183">
              Includes 2 FREE Bonuses + Audiobook Gift!
            </div>

            <CTAButton className="text-lg py-4 px-6 shadow-lg" fullWidth data-id="element-184">
              GET INSTANT ACCESS NOW — $29.97
            </CTAButton>

            <div className="flex items-center justify-center gap-2 text-gray-400 text-xs mt-4" data-id="element-185">
              <Shield size={14} data-id="element-186" />
              <span data-id="element-187">Secure checkout · Instant delivery via email</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}